import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import * as $ from 'jquery';
import {TarjetasListComponent} from './tarjetas-list.component';
import * as myGlobals from './../global';
import {NgForm} from "@angular/forms";
import { errorMessageFromAjax } from '../services/ajax-error';

@Component({
  selector: 'pm-add-tarjeta',
  templateUrl: './add-tarjeta.component.html',
  styleUrls: ['./add-tarjeta.component.sass']
})
export class AddTarjetaComponent implements OnInit, OnDestroy, AfterViewInit {
  public pageTitle = 'Nuevo Tarjeta';

  formData = {
    id: 0,
    name: '',
  };

  constructor(private parent: TarjetasListComponent) {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    $('a[rel=marca-tarjeta]').addClass('selected');
  }

  cancelTarjeta(): void {
    this.parent.showTarjetas = true;
    this.parent.showAddTarjeta = false;
  }

  addTarjeta(form: NgForm): void {

    console.log('addTarjeta: form: ', form);
    if (form.invalid) {
      Object.values(form.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }

    const parentRef = this.parent;
    const formData = {
      id: 0,
      brand: form.value.name /* $('input[name=name]').val(),
      status: $('#myselect option:selected').val() */
    };
    $.ajax({
      url: myGlobals.baseApi + '/webadmin/v1/cardbrand',
      dataType: 'json',
      headers: {
        sessionToken: localStorage.getItem('sessionToken')
      },
      contentType: 'application/json; charset=utf-8',
      type: 'POST',
      // data: JSON.stringify(form.valueOf())
      data: JSON.stringify(formData)
    }).done(function (response) {
      //
      console.log('Add sucess!!');
      parentRef.showTarjetas = true;
      parentRef.showAddTarjeta = false;
    }).fail(function(jqXHR) {
      alert('No se pudo dar de alta la marca: ' + errorMessageFromAjax(jqXHR));
    });

  }

  ngOnDestroy() {
    $('a[rel=marca-tarjeta]').removeClass('selected');
  }
}
